<template>
<div class="chapter">
<div class="inner_page">
<h1 class="main">Nicaragua, 1961-1990. Volume 1</h1>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// title.vue?e118d0a2